package com.arena_web.data.dto

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.jsonPrimitive

@Serializable
data class NotificationDto(
    val id: String,
    val type: String,
    val title: String,
    val body: String? = null,
    val dataJson: String? = null,
    val isRead: Boolean,
    val createdAt: String
) {
    fun parseDataJson(): Map<String, String> {
        if (dataJson.isNullOrBlank()) return emptyMap()
        return try {
            val obj = Json.decodeFromString<JsonObject>(dataJson)
            obj.mapValues { it.value.jsonPrimitive.content }
        } catch (_: Exception) {
            emptyMap()
        }
    }

    val isActionable: Boolean
        get() = type.uppercase() in setOf("EVENT_JOIN_REQUEST", "EVENT_TEAM_INVITE")
}

@Serializable
data class NotificationsPageDto(
    val notifications: List<NotificationDto>,
    val unreadCount: Long
)
